import { apiClient, ApiResponse } from "./api";

export interface LoginRequest {
  email: string;
  password: string;
}

export interface RegisterRequest {
  name: string;
  email: string;
  password: string;
}

export interface AuthResponse {
  user: {
    id: string;
    name: string;
    email: string;
  };
  token: string;
}

export interface PhoneLoginCodeRequest {
  telephoneNo: string;
}

export interface PhoneLoginRequest {
  telephoneNo: string;
  code: string;
}

export interface PhoneLoginResponse {
  userExists: boolean;
  accessToken?: string;
  refreshToken?: string;
}

export interface RefreshTokenRequest {
  refreshToken: string;
}

export interface RefreshTokenResponse {
  accessToken: string;
  refreshToken: string;
}

export class AuthService {
  async getPhoneLoginCode(
    request: PhoneLoginCodeRequest
  ): Promise<ApiResponse<void>> {
    const params = new URLSearchParams({ telephoneNo: request.telephoneNo });
    return apiClient.get<void>(`/users/signin/code?${params.toString()}`);
  }

  async phoneLogin(
    request: PhoneLoginRequest
  ): Promise<ApiResponse<PhoneLoginResponse>> {
    return apiClient.post<PhoneLoginResponse>("/users/signin", request);
  }

  async refreshToken(
    request: RefreshTokenRequest
  ): Promise<ApiResponse<RefreshTokenResponse>> {
    return apiClient.post<RefreshTokenResponse>("/users/refresh", request);
  }
}

export const authService = new AuthService();
